import React, { useState, useCallback, useEffect } from 'react';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import styles from './range.module.scss';

const Range = ({
  label,
  min,
  max,
  initialValue,
  initialMin,
  initialMax,
  onChange,
  ...rest
}) => {
  const normalizedMin = Number.isFinite(Number(min)) ? Number(min) : 0;
  const rawMax = Number.isFinite(Number(max)) ? Number(max) : normalizedMin + 1;
  const isFixedRange = rawMax <= normalizedMin;
  const normalizedMax = rawMax > normalizedMin ? rawMax : normalizedMin + 1;

  const [value, setValue] = useState(() => {
    if (initialMin !== undefined && initialMax !== undefined && initialMin !== '' && initialMax !== '') {
      return { min: Number(initialMin), max: Number(initialMax) };
    }
    if (typeof initialValue !== 'undefined') {
      return { min: normalizedMin, max: initialValue };
    }
    return isFixedRange
      ? { min: normalizedMin, max: normalizedMin }
      : { min: normalizedMin, max: rawMax };
  });

  const onChangeRange = useCallback((v) => {
    if (isFixedRange) {
      setValue({ min: normalizedMin, max: normalizedMin });
      return;
    }
    setValue(v);
    if (onChange) {
      onChange(v);
    }
  }, [isFixedRange, normalizedMin, onChange]);

  useEffect(() => {
    if (initialMin !== undefined && initialMax !== undefined && initialMin !== '' && initialMax !== '') {
      setValue({ min: Number(initialMin), max: Number(initialMax) });
    } else if (typeof initialValue !== 'undefined') {
      setValue({ min: normalizedMin, max: initialValue });
    } else {
      setValue(
        isFixedRange
          ? { min: normalizedMin, max: normalizedMin }
          : { min: normalizedMin, max: rawMax }
      );
    }
  }, [initialValue, initialMin, initialMax, isFixedRange, normalizedMin, rawMax]);

  return (
    <div>
      <div className={styles.label}>
        <label>{label}</label>
      </div>
      <div className={styles.target}>
        <InputRange
          {...rest}
          disabled={Boolean(rest.disabled) || isFixedRange}
          value={value}
          minValue={normalizedMin}
          maxValue={normalizedMax}
          onChange={onChangeRange}
        />
      </div>
    </div>
  );
};

export default Range;
